import { PUBLIC_AVATAR_URL } from "../../constants/publicAssets";
import { guestDisplayName } from "./utils";

export function BonusesProfileCard({ authUser, balance, historyCount, reservationsCount }) {
  return (
    <article className="profileCard profileCard--inBonuses">
      <div className="profileCard__head">
        <div className="profileCard__avatar">
          <img
            className="profileCard__avatarImg"
            src={PUBLIC_AVATAR_URL}
            alt=""
            width={52}
            height={52}
            decoding="async"
          />
        </div>
        <div>
          <h3 className="profileCard__name">{guestDisplayName(authUser)}</h3>
          {authUser?.username ? (
            <p className="profileCard__username">@{authUser.username}</p>
          ) : null}
        </div>
      </div>

      {authUser?.promo_profile_completed_at ||
      authUser?.promo_birthday_completed_at ||
      authUser?.promo_phone_completed_at ||
      authUser?.promo_channel_completed_at ? (
        <div className="profileCard__guestProfile">
          <dl className="profileCard__dl profileCard__dl--compact">
            {authUser?.promo_profile_completed_at ? (
              <>
                <div>
                  <dt>Фамилия</dt>
                  <dd>{authUser.profile_last_name ?? "—"}</dd>
                </div>
                <div>
                  <dt>Имя</dt>
                  <dd>{authUser.profile_first_name ?? "—"}</dd>
                </div>
                <div>
                  <dt>Отчество</dt>
                  <dd>{authUser.profile_patronymic ?? "—"}</dd>
                </div>
                {authUser.profile_nickname ? (
                  <div>
                    <dt>Ник</dt>
                    <dd>{authUser.profile_nickname}</dd>
                  </div>
                ) : null}
              </>
            ) : null}
            {authUser?.promo_birthday_completed_at && authUser.profile_birth_date ? (
              <div>
                <dt>Дата рождения</dt>
                <dd>{String(authUser.profile_birth_date).slice(0, 10)}</dd>
              </div>
            ) : null}
            {authUser?.promo_phone_completed_at && authUser.profile_phone ? (
              <div>
                <dt>Телефон</dt>
                <dd>{authUser.profile_phone}</dd>
              </div>
            ) : null}
            {authUser?.promo_channel_completed_at ? (
              <div>
                <dt>Подписка на канал</dt>
                <dd>подтверждена</dd>
              </div>
            ) : null}
          </dl>
        </div>
      ) : null}

      <div className="profileCard__roles">
        <div>
          <span className="profileCard__pill">Клиент</span>
        </div>
        {authUser?.is_admin ? (
          <span className="profileCard__pill profileCard__pill--admin">Администратор</span>
        ) : null}
        {authUser?.is_hostess ? <span className="profileCard__pill">Хостес</span> : null}
      </div>

      <div className="profileCard__stats">
        <div className="profileCard__stat">
          <span className="profileCard__statLabel">Бонусы</span>
          <strong className="profileCard__statValue profileCard__statValue--bonus">{balance}</strong>
        </div>
        <div className="profileCard__stat">
          <span className="profileCard__statLabel">По QR</span>
          <strong className="profileCard__statValue">{historyCount}</strong>
        </div>
        <div className="profileCard__stat">
          <span className="profileCard__statLabel">Броней</span>
          <strong className="profileCard__statValue">{reservationsCount}</strong>
        </div>
      </div>

      <dl className="profileCard__dl">
        <div>
          <dt>Telegram ID</dt>
          <dd>{authUser?.telegram_id ?? "—"}</dd>
        </div>
      </dl>
    </article>
  );
}
